import { defineStore } from "pinia";
import { ref, computed } from "vue";
// import axios from "axios";

export const useTrackingStore = defineStore("tracking", () => {
  // State
  const travelId = ref(null);
  const driverId = ref(null);
  const lastReportedLocation = ref(null);
  let locationUpdateInterval = null;
  const activeGeolocationHook = ref(null);

  // Getters
  const isTracking = computed(() => locationUpdateInterval !== null);

  // Actions
  function startTravel({ newTravelId, newDriverId, geolocationHook }) {
    travelId.value = newTravelId;
    driverId.value = newDriverId;
    activeGeolocationHook.value = geolocationHook;

    // Without destructuring
    geolocationHook.startTracking();

    // Set up interval to report location to API
    locationUpdateInterval = setInterval(() => {
      if (geolocationHook.currentPosition.value) {
        reportLocationToApi(geolocationHook.currentPosition.value);
      }
    }, 5000);
  }

  function stopTravel() {
    try {
      // First clear the interval
      if (locationUpdateInterval) {
        clearInterval(locationUpdateInterval);
        locationUpdateInterval = null;
      }
    } catch (error) {
      console.error("Error clearing interval:", error);
    }

    try {
      // Then try to stop geolocation tracking
      if (activeGeolocationHook.value) {
        if (typeof activeGeolocationHook.value.stopTracking === "function") {
          activeGeolocationHook.value.stopTracking();
        } else {
          console.warn("stopTracking is not a function on geolocation hook");
        }
      } else {
        console.warn("No active geolocation hook found");
      }
    } catch (error) {
      console.error("Error stopping geolocation tracking:", error);
    } finally {
      // Always reset the hook reference
      activeGeolocationHook.value = null;
    }
  }

  async function reportLocationToApi(location) {
    console.log(
      travelId.value +
        ", " +
        driverId.value +
        ", " +
        location.lat +
        ", " +
        location.lng +
        ", " +
        location.heading +
        ", " +
        location.timestamp,
    );
    // try {
    //   await axios.post("/api/location-updates", {
    //     travel_id: travelId.value,
    //     driver_id: driverId.value,
    //     latitude: location.lat,
    //     longitude: location.lng,
    //     timestamp: location.timestamp,
    //   });

    lastReportedLocation.value = location;
    // } catch (error) {
    //   console.error("Failed to report location:", error);
    // }
  }

  return {
    // State
    travelId,
    driverId,
    lastReportedLocation,

    // Getters
    isTracking,

    // Actions
    startTravel,
    stopTravel,
    reportLocationToApi,
  };
});
